import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WebhookIcon(props: IconProps) {
    return <Icon {...props} iconKey={"webhook"}/>
}
